import React from 'react'
import {ToastContainer} from 'react-toastify'
import {KTCard, KTCardBody, KTIcon} from '../../../../_websoft/helpers'

const Galanterija: React.FC = () => {
    return (
        <KTCard>
            <ToastContainer />

            <KTCardBody className='py-6 py-lg-8'>
                {/* Header */}
                <div className='d-flex align-items-start align-items-md-center justify-content-between flex-column flex-md-row gap-3 mb-6'>
                    <div>
                        <h2 className='fw-bold mb-1'>Galanterija</h2>
                        <div className='text-muted'>Odaberite opciju da nastavite.</div>
                    </div>
                </div>

                <div className='row g-5'>
                    {/* Otvoren nalog */}
                    <div className='col-12 col-md-6 col-xl-4'>
                        <a
                            href='otvoren-nalog'
                            className='card bg-success hoverable h-100 border-0 shadow-sm'
                            style={{overflow: 'hidden'}}
                        >
                            <div className='card-body p-6 position-relative'>
                                {/* keep content above decorations */}
                                <div className='position-relative' style={{zIndex: 2}}>
                                    <div className='d-flex align-items-center gap-4'>
                                        {/* ✅ High contrast icon */}
                                        <span className='symbol symbol-55px symbol-circle bg-black bg-opacity-25 shadow'>
                      <span className='symbol-label'>
                        <KTIcon iconName='element-11' className='fs-2x text-white' />
                      </span>
                    </span>

                                        <div className='min-w-0'>
                                            <div className='text-white fw-bold fs-2 text-truncate'>Otvoren nalog</div>
                                            <div className='text-white text-opacity-75 fw-semibold'>
                                                Kreiraj ili nastavi postojeći nalog
                                            </div>
                                        </div>
                                    </div>

                                    <div className='d-flex align-items-center justify-content-between mt-6'>
                                        <span className='badge badge-light-success fw-bold'>Brzo</span>
                                        <span className='text-white fw-bold'>
                      Otvori <KTIcon iconName='arrow-right' className='fs-2 text-white ms-1' />
                    </span>
                                    </div>
                                </div>

                                {/* Decoration (behind) */}
                                <span
                                    className='position-absolute top-0 end-0 translate-middle-y'
                                    style={{
                                        zIndex: 1,
                                        width: 180,
                                        height: 180,
                                        borderRadius: 999,
                                        background: 'rgba(255,255,255,0.12)',
                                    }}
                                />
                            </div>
                        </a>
                    </div>

                    {/* Plavi nalog */}
                    <div className='col-12 col-md-6 col-xl-4'>
                        <a
                            href='plavi-nalog'
                            className='card bg-info hoverable h-100 border-0 shadow-sm'
                            style={{overflow: 'hidden'}}
                        >
                            <div className='card-body p-6 position-relative'>
                                <div className='position-relative' style={{zIndex: 2}}>
                                    <div className='d-flex align-items-center gap-4'>
                                        {/* ✅ High contrast icon */}
                                        <span className='symbol symbol-55px symbol-circle bg-black bg-opacity-25 shadow'>
                      <span className='symbol-label'>
                        <KTIcon iconName='element-11' className='fs-2x text-white' />
                      </span>
                    </span>

                                        <div className='min-w-0'>
                                            <div className='text-white fw-bold fs-2 text-truncate'>Plavi nalog</div>
                                            <div className='text-white text-opacity-75 fw-semibold'>
                                                Unos i praćenje plavog naloga
                                            </div>
                                        </div>
                                    </div>

                                    <div className='d-flex align-items-center justify-content-between mt-6'>
                                        <span className='badge badge-light-info fw-bold'>Standard</span>
                                        <span className='text-white fw-bold'>
                      Otvori <KTIcon iconName='arrow-right' className='fs-2 text-white ms-1' />
                    </span>
                                    </div>
                                </div>

                                {/* Decoration (behind) */}
                                <span
                                    className='position-absolute top-0 end-0 translate-middle-y'
                                    style={{
                                        zIndex: 1,
                                        width: 180,
                                        height: 180,
                                        borderRadius: 999,
                                        background: 'rgba(255,255,255,0.12)',
                                    }}
                                />
                            </div>
                        </a>
                    </div>
                </div>
            </KTCardBody>
        </KTCard>
    )
}

export default Galanterija
